export enum OshAttachmentEntityType {
    ActionItem = 'ActionItem',
    Assessment = 'Assessment'
}

export interface OshAttachment {
    id: number;
    entityType: OshAttachmentEntityType;
    entityId: number;
    fileName: string;
    contentType: string;
    fileSize: number;
    createdBy: string;
    createdAtUtc: string;
}
